import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-bootstrap-toggle';
import masterField from '../../../../../components/search-form/master-field';


class GongContactOwnerField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.onToggleEnable = this.onToggleEnable.bind(this);
  }

  onToggleEnable() {
    this.props.onToggle();
  }

  render() {
    const { disabled, value, active } = this.props;
    if (!active) {
      return null;
    }
    return (
      <div>
        <Toggle
          onClick={this.onToggleEnable}
          on={<span>Required</span>}
          off={<span>No Required</span>}
          onstyle="success"
          size="xs"
          offstyle="danger"
          active={value}
          disabled={disabled}
        />
        <div style={{ marginTop: '5px' }}>
          {value === false && <div>All Gong meetings will be considered.</div>}
          {value === true && <div>Only Gong meeting where the opportunity owner was present as a participant will be considered.</div>}
        </div>
      </div>
    );
  }
}

GongContactOwnerField.propTypes = {
  value: PropTypes.bool,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
};
GongContactOwnerField.defaultProps = {
  value: null,
  disabled: false,
  submitting: false,
  onToggle: () => {},
  active: false,
};
export default masterField(GongContactOwnerField);
